'use strict';

const release = require('../../../../cache-pubsite.md5').toString();
const sentry = require('../common/sentry');
sentry('https://3f0d93e232594d0b9fb1170be4edfa41@o468622.ingest.sentry.io/5496707', release);

require('../../../admin/assets/js/libs/cookieconsent.min');
require('../../../admin/assets/js/admin-core/related-address-fields');
require('../SmartNotification.min.js');
require('../common/index.js');

window.iq = window.iq || {};
window.iq.flash = require('../../../admin/assets/js/admin-core/flash');

window.jQuery(function () {
	if (window.iq.cookie_consent_config) {
		window.cookieconsent.initialise(window.iq.cookie_consent_config);
	}
});
